import { Config } from '@flowwai-frontend/bps-officer-web/env-config'
import {
   BPS_OFFICER_ASSETS_URL,
   COMMON_BASE_URL_PREFIX
} from '@flowwai-frontend/shared/constants'

export const ASSETS_BASE_URL = Config.ASSETS_BASE_URL

export const errorViewImageUrls = {
   someThingWentWrong: `${COMMON_BASE_URL_PREFIX}/icons/no-views-in-board.svg`,
   accessDeniedUrl: `${COMMON_BASE_URL_PREFIX}/icons/ld-rule-access-denied.svg`
}

export const AVATAR_TEXT_TYPE = 'Text'

export const AVATAR_IMAGE_TYPE = 'Image'

export const APP_LOGO_PATH = '/assets/images/app_logo_image.svg'

export const FILE_PREVIEW_NOT_SUPPORTED_IMAGE_URL = `${COMMON_BASE_URL_PREFIX}/icons/file-preview-not-supported.svg`

export const CAD_FILE_PREVIEW_NOT_SUPPORTED_IMAGE_URL = `${BPS_OFFICER_ASSETS_URL}/file-preview-not-supported_cad.svg`

export const TASK_DISCARDED_IMAGE_URL = `${COMMON_BASE_URL_PREFIX}/images/task-discarded.svg`
